export default __webpack_public_path__ + "static/media/arrow-back.68ea441f.svg";